import { render } from "./ImageItem.vue?vue&type=template&id=576ca7b2&scoped=true"
import script from "./ImageItem.vue?vue&type=script&lang=js"
export * from "./ImageItem.vue?vue&type=script&lang=js"

import "./ImageItem.vue?vue&type=style&index=0&id=576ca7b2&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\webencusco\\projects\\admin-carta\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-576ca7b2"]])

export default __exports__